import factorizeFetchLifecycleNames from "../../helpers/factorizeFetchLifecycleNames"
import { NAME_PREFIX } from "../../constants"

const crudActions = factorizeFetchLifecycleNames(
  [`create`, `read`, `update`, `remove`],
  NAME_PREFIX,
)

const processingActions = {
  processingStart: `${NAME_PREFIX}_PROCESS_START`,
  processingComplete: `${NAME_PREFIX}_PROCESS_COMPLETE`,
}

const releaseActions = {
  release: `${NAME_PREFIX}_RELEASE`,
}

const involveActions = {
  involve: `${NAME_PREFIX}_INVOLVE`,
}

/* Specifies actions which gives multiple effect */
export const multiple = {
  batch: `${NAME_PREFIX}_BATCH`,
}

/* Specify affective action types (which affects to data) */
export const affective = {
  ...crudActions,
  ...processingActions,
  ...releaseActions,
  ...involveActions,
  ...multiple,
}

/* Specify internal action types */
export const internal = {
  ...processingActions,
}

export default {
  ...crudActions,
  ...processingActions,
  ...releaseActions,
  ...involveActions,
  ...multiple,
}
